// =============================================================================
// Breeder / Variety Owner module — shared types
// =============================================================================

export type SynonymType = 'trial_code' | 'trade_name' | 'old_name' | 'translation';

export const SYNONYM_TYPE_OPTIONS: { value: SynonymType; label: string }[] = [
  { value: 'trial_code', label: 'Trial code' },
  { value: 'trade_name', label: 'Trade name' },
  { value: 'old_name',   label: 'Old name' },
  { value: 'translation', label: 'Translation' },
];

export interface CultivarSynonym {
  id: number;
  cultivar_id: number;
  synonym: string;
  type: SynonymType;
  language_code: string | null;
  valid_from: string | null;
  valid_until: string | null;
  notes: string | null;
  created_at: string;
  created_by_user_id: number | null;
}

export type SynonymFormData = Omit<
  CultivarSynonym,
  'id' | 'cultivar_id' | 'created_at' | 'created_by_user_id'
>;

export type ReleaseState = 'breeder_only' | 'region_licensor' | 'public';

export const RELEASE_STATE_OPTIONS: { value: ReleaseState; label: string; description: string }[] = [
  {
    value: 'breeder_only',
    label: 'Breeder only',
    description: 'Only the breeder owner can see this cultivar. Use for pre-PBR / patent material.',
  },
  {
    value: 'region_licensor',
    label: 'Region licensors',
    description: 'Visible to nominated region licensors. Each licensor controls grower release in their region.',
  },
  {
    value: 'public',
    label: 'Public',
    description: 'Visible to all platform orgs (used for fully released cultivars).',
  },
];

export interface CultivarRegionRelease {
  id: number;
  cultivar_id: number;
  region_code: string;
  released_to_growers: boolean;
  public_synonym_id: number | null;
  public_synonym?: string | null;
  released_at: string | null;
  released_by_user_id: number | null;
  notes: string | null;
  created_at: string;
  updated_at: string;
}

export type RegionLicensorState = 'pending' | 'approved' | 'rejected' | 'revoked';
export type RegionLicensorScope = 'all_cultivars' | 'specific';

export interface RegionLicensorGrant {
  id: number;
  breeder_org_id: number;
  breeder_org_name: string;
  breeder_claim_state: 'unclaimed' | 'claimed' | 'verified';
  licensor_org_id: number;
  licensor_org_name: string;
  region_code: string;
  scope: RegionLicensorScope;
  state: RegionLicensorState;
  claimed_by_user_id: number | null;
  claimed_at: string;
  approved_by_user_id: number | null;
  approved_at: string | null;
  notes: string | null;
}

export interface CreateGrantRequest {
  breeder_org_id?: number | null;
  licensor_org_id?: number;
  region_code: string;
  scope?: RegionLicensorScope;
  cultivar_ids?: number[];
  notes?: string | null;
  breeder_initiated?: boolean;
  placeholder_breeder?: {
    name: string;
    country?: string | null;
    website?: string | null;
  };
}
